import Box from '@mui/material/Box';
import { SxProps, Theme } from '@mui/material/styles';
import React, { useMemo } from 'react';

import { NotesCellProps } from './NotesCell.props';
import { sanitizeElement, stripHtmlTags } from '../../../utils/common';

const HTML_PATTERN = /<[a-z][\s\S]*>/i;

const RESET_BLOCK_SPACING = {
  '& p, & ul, & ol, & blockquote, & pre, & h1, & h2, & h3, & h4, & h5, & h6, & figure': {
    margin: 0,
    padding: 0,
  },
  '& ul, & ol': { paddingInlineStart: '1.25em' },
  '& img': { maxHeight: '1.4em', verticalAlign: 'middle' },
} as const;

export const NotesCell: React.FC<NotesCellProps> = ({ value, maxWidth, lineClamp = 2, sx }) => {
  const text = typeof value === 'string' ? value : '';
  const plain = useMemo(() => (text ? stripHtmlTags(text) : ''), [text]);

  if (!plain) return null;

  const isHtml = HTML_PATTERN.test(text);

  const containerSx: SxProps<Theme> = {
    maxWidth,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: lineClamp,
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    fontSize: 'inherit',
    lineHeight: 1.4,
    wordBreak: 'break-word',
    ...RESET_BLOCK_SPACING,
    ...sx,
  };

  if (isHtml) {
    return (
      <Box
        title={plain}
        sx={containerSx}
        dangerouslySetInnerHTML={{ __html: sanitizeElement(text) }}
      />
    );
  }

  return (
    <Box title={plain} sx={containerSx}>
      {plain}
    </Box>
  );
};
